

export const zoneColumns = [
    {
        name: "Area",
        selector: (row) => row["area"],
        sortable: true,
        center: true,

    },
    {
        name: "Zone",
        selector: (row) => row["zone"],
        sortable: true,
        center: true,
    },
    {
        name: "Service City",
        selector: (row) => row["serviceCityName"],
        sortable: true,
        center: true,

    },
    {
        name: "Available",
        selector: (row) => row["isAvailable"],
        sortable: true,
        center: true,

    },
    {
        name: "",
        cell: (row) => row["action"],
        sortable: true,
        center: true,
        width: "30px",
    },
    {
        name: "Deleted",
        selector: (row) => row["Deleted"],
        sortable: true,
        center: true,
        width:"0",
        omit:true,
    },

];
